import React, { useCallback } from "react";

import { css } from "@compiled/react";
import {
    UniformSlot,
    UniformSlotWrapperComponentProps
} from "@uniformdev/canvas-react";

import { token } from "@atlaskit/tokens";

import { ContentBlock } from "@/libraries/design/components/content-block/src/content-block";
import { BgColors } from "@/libraries/design/components/link/src/link";
import { TabDataType, TabsSection } from "@/libraries/design/patterns/tabs/src";
import { Row } from "@/libraries/wpl/foundations/src/grid";

export interface UniformTabsProps {
    headerText: string;
    subHeaderText?: string;
    enableRovoBorder?: boolean;
    enableResponsiveTabSize?: boolean;
    bgColor?: BgColors;
}

const uniformTabsContainerStyles = css({
    display: "flex",
    flexDirection: "column",
    gap: token("space.500"),
    width: "100%",
    overflow: "hidden"
});

const UniformTabs12Col: React.FC<UniformTabsProps> = ({
    headerText,
    subHeaderText,
    bgColor = "bgWhite",
    enableRovoBorder = false,
    enableResponsiveTabSize = false
}) => {
    const renderTabs: React.ComponentType<UniformSlotWrapperComponentProps> =
        useCallback(
            ({ items }) => {
                const tabsData = items.map((item, index) => {
                    const params =
                        // @ts-ignore
                        item.props?.children?.props?.data?.parameters;

                    return {
                        id: params?.id?.value ?? `tab-${index}`,
                        title: params?.title?.value,
                        iconUrl: params?.iconUrl?.value,
                        tabComponent: item
                    } as TabDataType;
                });

                return (
                    <TabsSection
                        alignment="center"
                        tabsData={tabsData}
                        tabSize={"large"}
                        bgColor={bgColor}
                        enableRovoBorder={enableRovoBorder}
                        enableResponsiveTabSize={enableResponsiveTabSize}
                    />
                );
            },
            [bgColor, enableRovoBorder, enableResponsiveTabSize]
        );

    return (
        <div css={uniformTabsContainerStyles}>
            {(headerText || subHeaderText) && (
                <Row layout="8">
                    <ContentBlock
                        title={headerText}
                        text={subHeaderText}
                        titleAs="h2"
                        alignment="center"
                    />
                </Row>
            )}
            <UniformSlot name="tabs" wrapperComponent={renderTabs} />
        </div>
    );
};

export default UniformTabs12Col;
